import { BRAND, FONTS } from '../styles/tokens';
import { ASSESSMENTS } from '../data/assessments';
import { pagePath } from '../data/pages';
import { AssessmentQuiz } from './Assessment';
import { PageHero } from './PageShell';
import { useIsMobile } from '../hooks/useIsMobile';
import type { LeadPrefill } from '../types';

interface Props { id: string; onLead: (p: LeadPrefill) => void }

const CRUMBS = [{ label: 'Home', href: '/' }, { label: 'Assessments', href: '/#assessments' }];

export function AssessmentPage({ id, onLead }: Props) {
  const assessment = ASSESSMENTS.find(a => a.id === id);
  const m = useIsMobile();
  if (!assessment) return <NotFound crumbs={CRUMBS} what="assessment" />;
  const others = ASSESSMENTS.filter(a => a.id !== id);

  return (
    <>
      <PageHero eyebrow="Free Assessment" icon={assessment.icon} title={assessment.title} subtitle={assessment.subtitle} crumbs={CRUMBS}>
        <p style={{ fontFamily: FONTS.body, fontSize: 13, color: 'rgba(255,255,255,0.45)', marginTop: 16 }}>About 1–2 minutes · Your answers are private, never stored or shared · An educational tool, not a clinical or legal instrument</p>
      </PageHero>

      {/* id="assessments" so the quiz's own scroll-into-view helper works on this page too */}
      <section id="assessments" style={{ background: BRAND.white, padding: 0 }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <AssessmentQuiz assessment={assessment} onLead={onLead} onBack={() => window.location.assign('/#assessments')} />
        </div>
      </section>

      <section style={{ background: BRAND.cream, padding: m ? '48px 20px' : '72px 24px' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <h2 style={{ fontFamily: FONTS.heading, fontSize: m ? 24 : 30, fontWeight: 700, color: BRAND.navy, marginBottom: 20 }}>Other assessments</h2>
          <div style={{ display: 'grid', gridTemplateColumns: m ? '1fr' : 'repeat(2, 1fr)', gap: 12 }}>
            {others.map(a => (
              <a key={a.id} href={pagePath('assessment', a.slug)} style={{ display: 'flex', gap: 12, alignItems: 'flex-start', background: BRAND.white, border: `1.5px solid ${BRAND.border}`, borderRadius: 12, padding: 18, textDecoration: 'none' }}>
                <span aria-hidden style={{ fontSize: 24 }}>{a.icon}</span>
                <span>
                  <span style={{ display: 'block', fontFamily: FONTS.heading, fontSize: 18, fontWeight: 700, color: BRAND.navy }}>{a.title}</span>
                  <span style={{ display: 'block', fontFamily: FONTS.body, fontSize: 12, color: BRAND.warm, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', marginTop: 2 }}>{a.subtitle}</span>
                </span>
              </a>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export function NotFound({ crumbs, what }: { crumbs: { label: string; href: string }[]; what: string }) {
  return (
    <>
      <PageHero eyebrow="Not found" title={`That ${what} doesn't exist`} crumbs={crumbs} />
      <section style={{ background: BRAND.white, padding: '48px 24px', textAlign: 'center' }}>
        <a href="/" style={{ fontFamily: FONTS.body, fontSize: 15, fontWeight: 600, color: BRAND.warmDark }}>← Back to the home page</a>
      </section>
    </>
  );
}
